function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 388.89 344.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0000",
      strokeWidth: 0
    },
    d: "M0 0h388.89v344.4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.63 88.69h-97.12l-15.96 28.76h97.05zm-88.82-14.1 166.43.39 23.36-40.55H150.79zm-56.53 97.43 97.3.47-19.18 32.81-62.01 104.67L310.2 131.15l-215.99.01z",
    style: {
      strokeWidth: 0,
      fill: "#00e771"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo_small.ba43473f358f632194da95b7c2c40e29.svg";
export { ForwardRef as ReactComponent };